import { parse, format } from 'json-rpc-protocol';
import { encodeToStr, decodeFromStr } from "./coder";
export class JsonRPCClient {
    constructor(connector, notifiers) {
        this.connector = connector;
        this.notifiers = notifiers;
        this.id = 0;
        this.executors = {};
        this.connector.on('message', data => this.onMessage(data));
        this.connector.on('close', () => this.onClose());
    }
    onMessage(data) {
        const mesg = parse(data);
        switch (mesg.type) {
            case 'notification':
                return this.onNotify(mesg.method, mesg.params.map(decodeFromStr));
            case 'response':
                return this.executors[Number(mesg.id)]?.resolve(decodeFromStr(mesg.result));
            case 'error':
                return this.executors[Number(mesg.id)]?.reject(mesg.error.message);
        }
    }
    async request(method, params = []) {
        return new Promise((resolve, reject) => {
            const reqId = this.id++;
            this.executors[reqId] = { resolve, reject };
            const req = format.request(reqId, method, params.map(encodeToStr));
            this.connector.send(req);
        });
    }
    onNotify(type, data) {
        this.notifiers[type](...data);
    }
    onClose() {
    }
}
//# sourceMappingURL=JsonRPCClient.js.map